import React from "react";
import styles from "./LogoutModal.module.css";

const LogoutModal = (props) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h4 className={styles.title}>Confirm Logout</h4>
        <p className={styles.text}>
          Are you sure you want to log out?
        </p>

        <div className={styles.actions}>
          <button onClick={props.handleLogout} className={styles.confirmBtn}>
            Logout
          </button>
          <button
            onClick={props.handleCancelLogout}
            className={styles.cancelBtn}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
